import React, { useState, useEffect } from 'react';
import { Table, Spin } from 'antd';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { actividadeconomica } from '../../../services/perfiles/conponentesServices';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const Actividadeconomica = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [barChartData, setBarChartData] = useState(null);

    const labels = ['Primaria', 'Secundaria', 'Terciaria', 'Peso Relativo', 'Valor Agregado'];

    useEffect(() => {
        if (municipioId) {
            fetchData();
        }

    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await actividadeconomica(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;

                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                    updateBarChartData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const updateBarChartData = (data) => {
        const newBarChartData = {
            labels: ['Primaria', 'Secundaria', 'Terciaria', 'Peso Relativo', 'Valor Agregado'],
            datasets: [
                {
                    label: '',
                    data: [
                        data.reduce((acc, item) => acc + parseFloat(item.punt_primaria), 0),
                        data.reduce((acc, item) => acc + parseFloat(item.punt_secundaria), 0),
                        data.reduce((acc, item) => acc + parseFloat(item.punt_terciaria), 0),
                        data.reduce((acc, item) => acc + parseFloat(item.punt_peso_relativo), 0),
                        data.reduce((acc, item) => acc + parseFloat(item.punt_valor_agregado), 0)
                    ],
                    backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#4BC0C0', '#9966FF'],
                }
            ]
        };
        setBarChartData(newBarChartData);
    };

    const columns = [
        {
            title: 'Sector',
            dataIndex: 'sector',
            key: 'sector',
        },
        {
            title: 'Actividad',
            dataIndex: 'actividad',
            key: 'actividad',
        },
        {
            title: 'Participación (Precios corrientes M.M)',
            dataIndex: 'participacion',
            key: 'participacion',
        },
    ];


    const transformedData = data.flatMap((item, index) => [
        {
            key: `${index}-primaria`,
            sector: 'Primaria',
            actividad: item.act_primaria,
            participacion: parseFloat(item.punt_primaria), // Convertir a número
        },
        {
            key: `${index}-secundaria`,
            sector: 'Secundaria',
            actividad: item.act_secundaria,
            participacion: parseFloat(item.punt_secundaria), // Convertir a número
        },
        {
            key: `${index}-terciaria`,
            sector: 'Terciaria',
            actividad: item.act_terciaria,
            participacion: parseFloat(item.punt_terciaria), // Convertir a número
        },
        {
            key: `${index}-peso_relativo`,
            actividad: 'Valor agregado (miles de millones de pesos)',
            participacion: parseFloat(item.punt_peso_relativo), // Convertir a número
        },
        {
            key: `${index}-valor_agregado`,
            actividad: 'Peso relativo del Municipio en el valor agregado departamental (%)',
            participacion: parseFloat(item.punt_valor_agregado), // Convertir a número
        },
    ]);


    return (
        <div className="page-content">
            <h3>Información de Actividad Económica</h3>
            {loading ? (
                <Spin size="large" />
            ) : (
                <div>
                    <div className="table-container">
                        <Table
                            columns={columns}
                            dataSource={transformedData}
                            pagination={false}
                            scroll={{ x: '100%' }}
                            footer={() => <div>Fuente: {data.length > 0 ? data[0].fuente : 'N/A'}</div>}
                        />
                    </div>
                    <h4>Distribución Actividada Economica</h4>
                    <div className="chart-container">
                        {barChartData && (
                            <Bar
                                data={barChartData}
                                options={{
                                    indexAxis: 'y',
                                    scales: {
                                        x: {
                                            beginAtZero: true,
                                        },
                                        y: {
                                            beginAtZero: true,
                                            ticks: {
                                                callback: function (value, index, values) {
                                                    return labels[index];
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
export default Actividadeconomica;
